import * as React from 'react';

import humanInsight from './human-insight/human-insight.cmap';
import insight from './insight/insight.cmap';
import performanceInsight from './performance-insight/performance-insight.cmap';

const Types: { [key: string]: React.ReactType } = {
    ...insight,
    ...humanInsight,
    ...performanceInsight,
};

export default Types;
